<template>
  <div class="RTEAO-home">
    <div class="page-list">
      <div class="page-card" v-for="item in pageList" :key="item.title" @click="toPage(item.route)">
        <img :src="item.img" :alt="item.title" />

        <span>{{ item.title }}</span>
      </div>
    </div>

    <footer class="RTEAO-footer">
      <img src="/static/logo.svg" />
      <p>版权所有：©Copyright HT-Nova 2025 备案号：京ICP备2025066597号</p>
      <p>销售热线：400-880-3370 售后服务：400-609-6782 市场销售：sales@htnova.com</p>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageList: [
        {
          title: '实时态势',
          img: '/static/image/rteao-monitor/real-time-situation.png',
          route: 'RTEAOMonitorSituation'
        },
        {
          title: '历史回溯',
          img: '/static/image/rteao-monitor/historical-review.png',
          route: 'RTEAOMonitorHistoryReview'
        },
        {
          title: 'AI预测',
          img: '/static/image/rteao-monitor/ai-prediction.png',
          route: 'RTEAOMonitorAIPrediction'
        },
        {
          title: 'AI训练',
          img: '/static/image/rteao-monitor/ai-training.png',
          route: 'RTEAOMonitorAITraining'
        },
        {
          title: '上报记录',
          img: '/static/image/rteao-monitor/report-record.png',
          route: 'RTEAOMonitorReport'
        }
      ]
    };
  },
  methods: {
    toPage(route) {
      this.$router.push({
        name: route
      });
    }
  }
};
</script>

<style lang="scss">
.RTEAO-home {
  width: 100%;
  height: 100%;

  padding-top: 84px;

  box-sizing: border-box;

  font-family: Source Han Sans CN, Source Han Sans CN;

  background: url('/static/image/rteao-monitor/background.png') 0 0 / 100% 100% no-repeat;

  .RTEAO-footer {
    height: 18%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: #147bb6;
    font-size: 0.9rem;

    background: rgba(0, 0, 0, 0.6);
    border-radius: 0px 0px 0px 0px;

    img {
      margin-bottom: 10px;
    }
  }

  .page-list {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3.9vw;

    height: 82%;

    .page-card {
      width: 13.69vw;
      height: 28vw;

      border-radius: 10px;
      border: 0px solid transparent;
      box-sizing: border-box;

      background: linear-gradient(180deg, rgb(32 113 208 / 0.7) 0%, rgb(13 37 71 / 0.7) 100%);

      display: flex;
      flex-direction: column;
      align-items: center;

      cursor: pointer;
      transition: all 0.3s ease;

      img {
        width: 70%;

        margin-top: 3.8vw;
      }

      span {
        font-size: 2rem;
        // color: #147bb6;
        color: #aaa;

        margin-top: 5.4vw;

        user-select: none;
      }

      &:hover {
        width: 15.78vw;
        height: 32.29vw;

        border: 2px solid rgba(60, 180, 200, 0.9);

        // border-image: linear-gradient(180deg, rgba(85, 243, 255, 1), rgba(8, 88, 124, 1)) 2 2;

        background: linear-gradient(180deg, rgb(33, 169, 248, 0.7) 0%, rgb(13, 43, 83, 0.7) 100%);

        span {
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
